import React from 'react';
import { Switch } from '../../../../components/ui/switch';
import { Label } from '../../../../components/ui/label';



export default function ToggleSwitch({ label, checked, onCheckedChange }) {
  return (
    <div className="flex items-center justify-between">
      <Label className="text-sm">{label}</Label>
      <Switch checked={checked} onCheckedChange={onCheckedChange} />
    </div>
  );
}
